import { render, staticRenderFns } from "./AromaShop.vue?vue&type=template&id=51b5e1b7&scoped=true"
import script from "./AromaShop.vue?vue&type=script&lang=js"
export * from "./AromaShop.vue?vue&type=script&lang=js"
import style0 from "./AromaShop.vue?vue&type=style&index=0&id=51b5e1b7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b5e1b7",
  null
  
)

export default component.exports